<div onsip-grid-placement-shelf>
  <div class="first-column">
    <section>
      <div class="mat-body-1 m-b-12">MAC Address</div>
      <div>{{ phoneInfo.macAddress | macAddress }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Make</div>
      <div>{{ phoneInfo.make }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Model</div>
      <div>{{ phoneInfo.model }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Time zone (GMT)</div>
      <div>{{ displayTimezone }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Phone password</div>
      <div>{{ phoneInfo.webPassword }}</div>
    </section>
  </div>
  <div class="second-column">
    @if(phoneFeatures.Directory) {
    <section>
      <div class="mat-body-1 m-b-12">Company Directory</div>
      <div>{{ phoneInfo.directory ? "yes" : "none" }}</div>
    </section>
    } @if(phoneFeatures.Intercom) {
    <section>
      <div class="mat-body-1 m-b-12">Intercom</div>
      <div>{{ phoneInfo.intercom ? "yes" : "none" }}</div>
    </section>
    } @if(phoneFeatures.NATKeepalive){
    <section>
      <div class="mat-body-1 m-b-12">NAT Keepalive</div>
      <div>{{ phoneInfo.natKeepalive ? "yes" : "none" }}</div>
    </section>
    } @if(phoneFeatures.EasyTransfer) {
    <section>
      <div class="mat-body-1 m-b-12">Easy transfer</div>
      <div>{{ phoneInfo.easyTransfer ? "yes" : "none" }}</div>
    </section>
    } @if(phoneFeatures.WebInterface){
    <section>
      <div class="mat-body-1 m-b-12">Enable web interface</div>
      <div>{{ phoneInfo.webInterface ? "yes" : "none" }}</div>
    </section>
    } @if(phoneFeatures.EndToEndEncryption){
    <section>
      <div class="mat-body-1 m-b-12">End to end Encryption</div>
      <div>{{ phoneInfo.endToEndEncryption ? "yes" : "none" }}</div>
    </section>
    } @if (noFeatures) {
    <section>
      <span>
        Advanced features are unavailable for this make and model. To see which makes and models
        feature advanced options,
        <a class="support-link" href="https://support.onsip.com" target="_blank"
          >visit the knowledgebase.</a
        >
      </span>
    </section>
    }
  </div>
  <div class="third-column">
    @if(phoneFeatures.DigitMap) {
    <section>
      <div class="mat-body-1 m-b-12">Custom digit map</div>
      <div>{{ phoneInfo.digitmap.length ? phoneInfo.digitmap : "none" }}</div>
    </section>
    }
    <section>
      <div class="mat-body-1 m-b-12">Provision status</div>
      <div [ngClass]="{ 'not-provisioned': !phoneInfo.encryptionKey }">
        {{ phoneInfo.encryptionKey ? "Provisioned" : "Not provisioned" }}
      </div>
      @if (!phoneInfo.encryptionKey) {
      <div>Please restart your phone to complete set-up</div>
      }
    </section>
    <section>
      <div class="mat-body-1 m-b-12 span-with-icon">
        <span>Test phone configuration</span>
        <mat-icon
          class="question-hover-icon"
          onsip-question-mark-tooltip
          matTooltipClass="onsip-tooltip-background"
          matTooltip="Make a test call to ensure this phone can make and receive calls."
          matTooltipPosition="above"
        >
          help_outline
        </mat-icon>
      </div>
      <button
        [disabled]="!phoneInfo.encryptionKey"
        [customDisable]="!phoneInfo.encryptionKey"
        mat-button
        color="primary"
        onsipNewCall
        [noCallNavigate]="true"
        [remoteAor]="remoteAor"
      >
        Make a test call
      </button>
    </section>
    <section>
      <div class="mat-body-1 m-b-12 span-with-icon">
        <span>Security key reset</span>
        <mat-icon
          class="question-hover-icon"
          onsip-question-mark-tooltip
          matTooltipClass="onsip-tooltip-background"
          matTooltip="Reset the security key on OnSIP's server only if you have done a factory reset of your phone."
          matTooltipPosition="above"
        >
          help_outline
        </mat-icon>
      </div>
      <button
        [disabled]="!phoneInfo.encryptionKey"
        mat-button
        color="primary"
        (click)="openKeyResetDialog()"
      >
        Generate key
      </button>
    </section>
  </div>
</div>
<div class="page-view-controls">
  <button mat-flat-button class="toggle-button" color="primary" (click)="toggleInfoPanel()">
    Edit Info
  </button>
</div>
